import React, { useCallback, useEffect, useState } from 'react';
import ShelfToolBar from '../components/shelf-number-management/shelfToolBar';
import { Box } from '@mui/material';
import ShelfTable from '../components/shelf-number-management/shelfTable';
import { get_shelf_system } from '../features/shelfNumberSystem/shelfNumberService';

function ShelfScreen() {
  const [isLoading, setIsLoading] = useState(false);
  const [shelfData, setShelfData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [reloadShelf, setReloadShelf] = useState(false);
  const [search, setSearch] = useState("");

  // Pagination states
  const [page, setPage] = useState(0); // 0-indexed page
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const pharmacyId = parseInt(localStorage.getItem("pharmacyId") || "0")

  const getShelf = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await get_shelf_system({
        page: page + 1,
        limit: rowsPerPage,
        search: search.trim(),
        pharmacy_id: pharmacyId,
      });
  
      setShelfData(res?.data?.shelf || []);
      setTotalCount(res?.data?.pagination?.total || 0);
      
    } catch (error: any) {
      console.error("Error fetching shelf data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [page, rowsPerPage, search, reloadShelf]);
  

  useEffect(() => {
    getShelf();
  }, [getShelf, reloadShelf]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <Box sx={{ flexGrow: 1, px: 1 }}>
      <Box sx={{ bgcolor: "white", my: "1.2%", minHeight: "80vh", px: 2, py: 0.5 }}>
        <Box>
          <ShelfToolBar
            setReloadShelf={setReloadShelf}
            setSearch={setSearch}
          />
        </Box>
        <Box>
          <ShelfTable
            shelfData={shelfData}
            setReloadShelf={setReloadShelf}
            page={page}
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            isPagination={false}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ShelfScreen;
